module.exports = __webpack_public_path__ + "img/icon-telephone.0688c60c.svg";